import React from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";
import { StaffingPeopleContext } from "./components/StaffingPeopleContext";
import PersonProfile from "./components/PersonProfile";

const StaffingPersonApp = (props) => (
  <StaffingPeopleContext.Provider value={props}>
    <div className="od-themed" style={{ padding: 24 }}>
      <PersonProfile />
    </div>
    <ToastContainer icon={false} />
  </StaffingPeopleContext.Provider>
);

StaffingPersonApp.propTypes = {
  tabPaths: PropTypes.object.isRequired,
  permissions: PropTypes.shape({ invite: PropTypes.bool.isRequired, readContactDetails: PropTypes.bool.isRequired }).isRequired,
  paths: PropTypes.shape({ create: PropTypes.string.isRequired, invitations: PropTypes.string.isRequired, timeCards: PropTypes.string, timeCard: PropTypes.string }).isRequired,
  person: PropTypes.object.isRequired,
  profile: PropTypes.shape({
    hours: PropTypes.object.isRequired,
    upcomingShifts: PropTypes.arrayOf(PropTypes.object).isRequired,
    availability: PropTypes.arrayOf(PropTypes.object),
    timeOff: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default StaffingPersonApp;
